import { makeStyles } from "@material-ui/core/styles";

import { Theme } from "@material-ui/core";
import { BrandingType, IShow } from "@evennt-tech/api-v2-core";

export const SHOW_BAR_HEIGHT = 132;

type Props = {
  show?: IShow;
  isExhibitor?: boolean;
};

const useStyles = makeStyles<Theme, Props>((theme) => ({
  appBar: ({ show }: Props) => ({
    height: SHOW_BAR_HEIGHT,
    zIndex: theme.zIndex.drawer + 10,
    paddingBottom: theme.spacing(1),
    boxShadow: "0px 1px 0px rgba(0, 0, 0, 0.15)",
    filter: "drop-shaxdow(0px 1px 0px rgba(0, 0, 0, 0.15))",
    backgroundColor: show?.branding?.bannerImage?.url
      ? "none"
      : theme.palette.common.white,
    backgroundSize: "cover",
    backgroundPosition: "center center",
    color: show?.branding?.bannerImage?.url
      ? theme.palette.common.white
      : theme.palette.common.black,
    "&::before": {
      content: "''",
      position: "absolute",
      display:
        show?.branding?.bannerImage?.url &&
        !show?.branding?.hideBannerOverlay &&
        show?.branding?.bannerType === BrandingType.IMAGE
          ? "block"
          : "none",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundSize: "cover",
      backgroundPosition: "center center",
      background:
        "linear-gradient(270deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 77.38%), linear-gradient(90deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 74.34%)",
    },
  }),
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
    padding: theme.spacing(0, 3, 0, 0),
  },
  sideLeft: {
    display: "flex",
    margin: theme.spacing(1.5, 0, 2.5, 0),
  },
  sideRight: {
    margin: theme.spacing(1.5, 0),
  },
  sideText: {
    paddingRight: theme.spacing(1.5),
    fontFamily: "Poppins",
  },
  notification: {
    display: "flex",
    marginRight: theme.spacing(1.5),
  },
  fullName: {
    color: "white",
  },
  fullNameLabel: {
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "16px",
    textAlign: "right",
    paddingTop: theme.spacing(0.5),
    textTransform: "capitalize",
  },
  roleLabel: () => ({
    fontWeight: 400,
    fontSize: "12px",
    textAlign: "right",
    paddingBottom: theme.spacing(0.5),
    textTransform: "capitalize",
    color: "#F5F5F5",
  }),
  avatar: {
    background: theme.palette.secondary.main,
    color: theme.palette.primary.main,
  },
  showInfoBar: {
    marginTop: theme.spacing(0.75),
    position: "relative",
    alignItems: "initial",
    // Same inset the bar used to apply for all of its children (see `appBar`).
    paddingRight: theme.spacing(3),
  },
  avatarContainer: {
    display: "flex",
    alignItems: "center",
    margin: "auto 0 auto auto",
    paddingRight: theme.spacing(2),
  },
  logo: {
    width: 52,
    height: 52,
    border: "1px solid rgba(0, 0, 0, 0.15)",
    borderRadius: theme.spacing(1),
  },
  showInfo: {
    display: "flex",
    alignItems: "center",
    margin: "auto auto auto 0",
    paddingLeft: theme.spacing(3),
  },
  showBarText: {
    padding: theme.spacing(2),
    color: "white",
  },
  showNameContainer: {
    marginLeft: theme.spacing(3),
  },
  contrastText: {
    color: `${theme.palette.contrastText.main} !important`,
  },
  contrastWrapper: {
    padding: theme.spacing(0.5, 0),
    background: "rgba(39, 41, 46, 0.20)",
    borderRadius: "6px",
  },
  showhubBtn: {
    color: "#fff",
    fontSize: "16px",
    fontWeight: 500,
    padding: theme.spacing(1.75, 2),
  },
  showhubLogo: {
    width: 18,
    height: 18,
    verticalAlign: "middle",
    marginRight: theme.spacing(0.25),
    marginLeft: theme.spacing(0.5),
  },
}));

export default useStyles;
